import { createContext } from 'react';

export const ResultsContext = createContext(null);
